import React from 'react';
import { Gutter, Layout, Well } from '@axiom/ui';
import type { OnboardingDetails } from '@axiom/validation';

import { EngagementDetailsFirstDayContactRow } from './EngagementDetailsFirstDayContactRow';

type Contact = NonNullable<OnboardingDetails['additionalContacts']>[number];

type EngagementDetailsFirstDayContactsProps = {
  name?: string;
  contacts: Contact[];
};

export const EngagementDetailsFirstDayContacts = ({
  name,
  contacts,
}: EngagementDetailsFirstDayContactsProps) => {
  return (
    <Gutter bottom="16px">
      <Layout
        name={name}
        direction="vertical"
        position="space-between"
        verticalGutter="16px"
      >
        {contacts.map(contact => {
          return (
            <Well
              background="light"
              key={[
                contact.name,
                contact.jobTitle,
                contact.email,
                contact.phoneNumber,
              ].join('|')}
            >
              <Layout
                direction="vertical"
                position="space-between"
                verticalGutter="8px"
              >
                <EngagementDetailsFirstDayContactRow
                  name="CLIENT_NAME"
                  label="Client Name:"
                  value={contact.name}
                />
                <EngagementDetailsFirstDayContactRow
                  name="JOB_TITLE"
                  label="Job Title:"
                  value={contact.jobTitle}
                />
                <EngagementDetailsFirstDayContactRow
                  name="EMAIL_CONTACT"
                  label="Email:"
                  value={contact.email}
                />
                <EngagementDetailsFirstDayContactRow
                  name="PHONE"
                  label="Phone:"
                  value={contact.phoneNumber}
                />
              </Layout>
            </Well>
          );
        })}
      </Layout>
    </Gutter>
  );
};
